export const isNumber = (n: unknown): n is number => Number(n) === n; // typeof value === 'number' && isFinite(value);
